import { TAG } from './constants'
import type { FrameMessage, LoaderMessage } from './types'

const hasWidgetTag = (data: unknown): data is { tag: typeof TAG } =>
  typeof data === 'object' && data !== null && (data as { tag?: unknown }).tag === TAG

export const isFrameMessage = (data: unknown): data is FrameMessage => hasWidgetTag(data)

export const isLoaderMessage = (data: unknown): data is LoaderMessage => hasWidgetTag(data)
